import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from './auth.service';
import { Users } from './users';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private title: Title,
    private meta: Meta,
  ) {
  }
  updateTitle(title: string= null, lang = 'en') {
    this.title.setTitle(title);
    this.meta.updateTag({name: 'og:title', content: title});
    this.meta.updateTag({name: 'og:locale', content: lang});
    this.meta.updateTag({name: 'og:site_name', content: 'MANPRO - PTSI'});
  }
  updateMetaInfo(desc, keywords, url) {
    this.meta.updateTag({ name: 'description', content: desc });
    if (keywords) { this.meta.updateTag({ name: 'keywords', content: keywords }); }
    this.meta.updateTag({ name: 'og:url', content: url });
    this.meta.updateTag({ name: 'og:description', content: desc });
}
}
